"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { env } from "../../utils/libs/env";

import type { ReactNode } from "react";

const defaultQueryOptions = {
  cacheTime: Number.POSITIVE_INFINITY,
  staleTime: 60 * 1000,
  refetchOnWindowFocus: false,
  retryOnMount: true,
  retry: false,
  refetchOnMount: false,
};

function createQueryClient(params: { isServer: boolean }) {
  return new QueryClient({
    defaultOptions: {
      queries: { ...defaultQueryOptions, gcTime: params.isServer ? 2 * 1000 : defaultQueryOptions.cacheTime },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (typeof window === "undefined") return createQueryClient({ isServer: true });
  if (!browserQueryClient) browserQueryClient = createQueryClient({ isServer: false });

  return browserQueryClient;
}

type QueryProviderT = {
  children: ReactNode;
};

export function QueryProvider({ children }: QueryProviderT) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      {children}

      {env.NEXT_PUBLIC_STAGE === "local" && <ReactQueryDevtools initialIsOpen={false} position="bottom" />}
    </QueryClientProvider>
  );
}
